/* RVA Threads flow2 swatch names (Oct 15 2026, J: "make sure to double check for stuff like this").
   Color names on the swatch buttons used to split mid-word ("Watermelo/n") or get cut off (long two-tone names
   like "Vintage Royal Sleeves/ Premium Heather Body"). Now a name wraps only at spaces and after a slash, and a
   word too wide for its swatch gets one hyphen at a syllable break ("Water-melon", "Indepen-dence"). The swatch
   rows grow to fit the longest name (style tag in sections/rva-youth-view.liquid). Touches only the visible label; the title, data-ci and
   color data stay as they were. */
(function(){
"use strict";
var SH=String.fromCharCode(173),ZW=String.fromCharCode(8203),STRIP=new RegExp("["+SH+ZW+"]","g"),ver=1,tries=0,pend=0,lt=0,cx=null,fk="",
ON={bl:1,br:1,ch:1,cl:1,cr:1,dr:1,fl:1,fr:1,gl:1,gr:1,ph:1,pl:1,pr:1,sh:1,st:1,th:1,tr:1,wh:1,wr:1,qu:1,chr:1,str:1,thr:1,spr:1,scr:1,spl:1,squ:1},
/* second halves of compound color names: "Hounds-tooth", "Stone-washed", "Butter-scotch" */
TAIL="washed catcher blossom scotch flower heather berry stone melon fruit grass tooth dance green night color colour water storm smoke shell burst cotta field light ground wood corn foam bird leaf wine wash land drop fire fly".split(" ");
function vow(w,i){var c=w.charAt(i).toLowerCase();if("aeiou".indexOf(c)>=0)return !(c==="u"&&i>0&&w.charAt(i-1).toLowerCase()==="q");return c==="y"&&i>0&&!vow(w,i-1)}
/* one soft hyphen: between the halves of a compound, else at the syllable break nearest the middle (3+ letters each side) */
function hy(w){
var n=w.length,v=[],c=[],i,k,a,b,cl,at,L,m,best,lw=w.toLowerCase();
if(n<6||/[^A-Za-z]/.test(w))return w;
for(i=0;i<TAIL.length;i++){L=TAIL[i].length;if(n-L>=3&&lw.slice(-L)===TAIL[i])return w.slice(0,n-L)+SH+w.slice(n-L)}
for(i=0;i<n;i++)if(vow(w,i))v.push(i);
for(k=0;k+1<v.length;k++){
a=v[k]+1;b=v[k+1];if(b===a)continue;
cl=w.slice(a,b).toLowerCase();at=b-1;
if(cl.length===1)at=a;
else{
for(L=Math.min(3,cl.length);L>=2;L--)if(ON[cl.slice(-L)]){at=b-L;break}
if(cl.charAt(at-a-1)==="c"&&cl.charAt(at-a)==="k")at++;
else if(cl.charAt(at-a-1)==="t"&&cl.slice(at-a,at-a+2)==="ch")continue;
}
if(at>=3&&n-at>=3)c.push(at);
}
if(!c.length)return w;
m=n/2;best=c[0];
for(k=1;k<c.length;k++)if(Math.abs(c[k]-m)<=Math.abs(best-m))best=c[k];
return w.slice(0,best)+SH+w.slice(best);
}
/* widths come from a canvas with the label's font: no page reflow per word (a reflow costs ~5 ms on these pages) */
function fnt(l){var s=getComputedStyle(l);return [s.fontStyle,s.fontWeight,s.fontSize,s.fontFamily].join(" ")+"|"+s.letterSpacing}
function wid(p,f){var i;if(!cx)cx=document.createElement("canvas").getContext("2d");if(f!==fk){i=f.lastIndexOf("|");cx.font=f.slice(0,i);if("letterSpacing" in cx)cx.letterSpacing=f.slice(i+1);fk=f}return cx.measureText(p).width}
function lay(raw,W,f){
return raw.split(" ").map(function(word){
return word.replace(/\/(?=[^\s\/])/g,"/\n").split("\n").map(function(p){
var q;if(wid(p,f)<=W+0.5)return p;
q=/^([A-Za-z]+)(\/?)$/.exec(p);
return q?hy(q[1])+q[2]:p;
}).join(ZW);
}).join(" ");
}
/* read every label first, then write, so a run costs one layout */
function run(){
var ls=document.querySelectorAll("#rvaCat .cLbl"),todo=[],miss=0,i,l,t,W,cur,raw,out;
for(i=0;i<ls.length;i++){
l=ls[i];t=l.firstChild;if(!t||t.nodeType!==3)continue;
W=l.clientWidth;if(!W){miss++;continue}
cur=t.nodeValue;
if(cur===l.__rvaO&&W===l.__rvaW&&ver===l.__rvaV)continue;
todo.push([l,t,W,cur,fnt(l)]);
}
for(i=0;i<todo.length;i++){try{
l=todo[i][0];t=todo[i][1];W=todo[i][2];cur=todo[i][3];
raw=cur===l.__rvaO?l.__rvaR:cur.replace(STRIP,"");
out=lay(raw,W,todo[i][4]);
l.__rvaR=raw;l.__rvaO=out;l.__rvaW=W;l.__rvaV=ver;
if(out!==cur)t.nodeValue=out;
}catch(e){}}
if(miss&&tries++<20)setTimeout(run,250);
}
function has(n){return n.nodeType===1&&(n.classList.contains("cLbl")||!!n.querySelector(".cLbl"))}
/* run just before the next paint, after the style page has set the grid's columns (rva-style-ss.js does that in a
   microtask after each redraw), then once more a moment later in case the layout settles late */
function soon(){
if(pend)return;pend=1;
var go=function(){pend=0;tries=0;run();clearTimeout(lt);lt=setTimeout(run,400)};
if(window.requestAnimationFrame&&!document.hidden)requestAnimationFrame(go);else setTimeout(go,0);
}
function boot(){
var rt;
new MutationObserver(function(recs){
for(var i=0;i<recs.length;i++){var a=recs[i].addedNodes;for(var j=0;j<a.length;j++)if(has(a[j])){soon();return}}
}).observe(document.body,{childList:true,subtree:true});
addEventListener("resize",function(){clearTimeout(rt);rt=setTimeout(function(){tries=0;run()},120)});
if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){ver++;soon()});
soon();
window.rvaSw={hy:hy,lay:lay,fnt:fnt,run:run};
}
if(document.body)boot();else document.addEventListener("DOMContentLoaded",boot);
})();